import axiosInstance from './axiosInstance'

export interface RouteSearchResponse {
  id: number
  schDate: string
  partnerName: string
  origin: string
  originAddress: string
  route: string
  destination: string
  destinationAddress: string
  destinationSelectedParams: string
  std?: String
  sta?:String
  remarks: string
  estimasi: string
  routeStatus: string
}

export const getOrigins = async (): Promise<string[]> => {
  try {
    const res = await axiosInstance.get('/rsvm/api/rsvm-route-sch/v1/origins')
    return res.data.data
  } catch (error) {
    console.error('Failed fetch origins', error)
    throw error
  }
}

export const getDestinations = async (origin: string): Promise<string[]> => {
  try {
    const res = await axiosInstance.get('/rsvm/api/rsvm-route-sch/v1/destinations', {
      params: {origin},
    })
    return res.data.data
  } catch (error) {
    console.error('Failed fetch origins', error)
    throw error
  }
}

export const searchRoute = async (
  origin: string,
  destination: string
): Promise<RouteSearchResponse[]> => {
  try {
    const res = await axiosInstance.get('/rsvm/api/rsvm-route-sch/v1/search', {
      params: {origin, destination},
    })
    return res.data.data
  } catch (error) {
    console.error('Failed fetch origins', error)
    throw error
  }
}
